let locales = {
    editNoteModal_chekbox: `seleziona per creare promemoria Email/Notifica`,
    editNoteModal_date: `Data`,
    editNoteModal_hour: `Orario`,
}

export default locales;